import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getOrderFormTypeList(params) {
  return request({
    url: URL.mdm.basicData.orderFormType,
    method: 'get',
    params
  })
}

export function saveOrderFormType(data) {
  return request({
    url: URL.mdm.basicData.orderFormType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delOrderFormType(uuid) {
  return request({
    url: URL.mdm.basicData.orderFormType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
